import { swSettings } from "app/common/services/swSettings";
import { NoTouchPurchaseConfirmationModal } from "app/components/no-touch-purchase-modal/confirmation-modal/NoTouchPurchaseConfirmationModal";
import { NO_TOUCH_PURCHASE_MODAL_STATE } from "app/components/no-touch-purchase-modal/noTouchPurchaseModalConstants";
import { NoTouchPurchaseSummaryModal } from "app/components/no-touch-purchase-modal/summary-modal/NoTouchPurchaseSummaryModal";
import { useNoTouchPurchaseModal } from "app/components/no-touch-purchase-modal/useNoTouchPurchaseModal";
import type { AddonTypeName } from "app/contexts/AddonStateContext/const";

interface INoTouchPurchaseModalProps {
    addonType: AddonTypeName | null;
    preselectQuantity?: number;
    preselectVariation?: string;
    setAddonType: (newAddonType: AddonTypeName | null) => void;
    onPurchaseAddonClick: (addonType: AddonTypeName | null, quantity?: number) => void;
}

export const NoTouchPurchaseModal = ({
    addonType,
    preselectQuantity,
    preselectVariation,
    setAddonType,
    onPurchaseAddonClick,
}: INoTouchPurchaseModalProps) => {
    const {
        isPrimaryModalOpen,
        modalState,
        selectedAddon,
        suggestions,
        handleCloseModal,
        handlePurchaseClick,
        handleConfirmClick,
        handleSelectedAddonChange,
        handlePurchaseSuccess,
        handlePurchaseError,
        handlePurchasePaymentError,
    } = useNoTouchPurchaseModal({ swSettings, addonType, setAddonType, onPurchaseAddonClick });

    if (!addonType) {
        return null;
    }

    return (
        <>
            <NoTouchPurchaseSummaryModal
                isOpen={isPrimaryModalOpen}
                isPurchaseFailed={modalState === NO_TOUCH_PURCHASE_MODAL_STATE.Error}
                addonType={addonType}
                preselectQuantity={preselectQuantity}
                preselectVariation={preselectVariation}
                selectedAddon={selectedAddon}
                suggestions={suggestions}
                onClose={handleCloseModal}
                onPurchaseClick={handlePurchaseClick}
                onSelectedAddonChange={handleSelectedAddonChange}
            />

            {modalState === NO_TOUCH_PURCHASE_MODAL_STATE.Success ||
            modalState === NO_TOUCH_PURCHASE_MODAL_STATE.InProgress ||
            modalState === NO_TOUCH_PURCHASE_MODAL_STATE.PaymentFailure ? (
                <NoTouchPurchaseConfirmationModal
                    selectedAddon={selectedAddon}
                    isPaymentFailed={modalState === NO_TOUCH_PURCHASE_MODAL_STATE.PaymentFailure}
                    onClose={handleCloseModal}
                    onConfirmClick={handleConfirmClick}
                    onPurchaseSuccess={handlePurchaseSuccess}
                    onPurchaseError={handlePurchaseError}
                    onPurchasePaymentError={handlePurchasePaymentError}
                />
            ) : null}
        </>
    );
};
